import PatientsTable from './PatientsTable';

export default PatientsTable;
